import { Route, Routes } from "react-router-dom";
import ReturnPath from "components/routes/ReturnPath";
import Contracts from "./Contracts";
import ContractCreateEdit from "./ContractCreateEdit";
import ContractDetails from "./ContractDetails";

const index = () => {
	return (
		<Routes>
			<Route element={<ReturnPath primaryPath="contracts" />}>
				<Route index element={<Contracts />} />
				<Route path='/create' element={<ContractCreateEdit />} />
				<Route path='/:id/edit' element={<ContractCreateEdit />} />
				<Route path='/:id/details' element={<ContractDetails />} />
			</Route>
		</Routes>
	);
};

export default index;
